import { render, staticRenderFns } from "./FollowPeople.vue?vue&type=template&id=53dffd2a&scoped=true&"
import script from "./FollowPeople.vue?vue&type=script&lang=js&"
export * from "./FollowPeople.vue?vue&type=script&lang=js&"
import style0 from "./FollowPeople.vue?vue&type=style&index=0&id=53dffd2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53dffd2a",
  null
  
)

export default component.exports